/**
 * @overview Utility to get the current header height
 * @module getHeaderHeight.js
 * @todo Return height based on whether subnav is present or not
 */

import { mapValues as _mapValues } from 'lodash';

import styles from '../assets-spa/css/exports/header.css';

const header = _mapValues(styles, (value) => {
  return parseFloat(value, 10) * 16;
});

export const getHeaderHeight = () => {
  if (window.matchMedia(`(max-width: 1023px)`).matches) {
    return header[`header-height-mobile`];
  }
  
  return header[`header-height`];
};

export const getHeaderAndSubnavHeight = () => {
  if (window.matchMedia(`(max-width: 1023px)`).matches) {
    return header[`header-height-mobile`] + header[`subnav-height`];
  }

  return header[`header-height`] + header[`subnav-height`];
};

export const getHeaderAndBuyBarHeight = () => {
  if (window.matchMedia(`(max-width: 767px)`).matches) {
    return header[`header-height-mobile`] + header[`subnav-height`];
  }

  return header[`header-height`] + header[`buybar-height`];
};
